import React, {Component} from 'react';
import {
  SafeAreaView,
  StyleSheet,
  View,
  Text,
  TextInput,
  TouchableOpacity,
  Platform,
  Alert,
  FlatList,
  Image,
  Dimensions,
  ScrollView,
} from 'react-native';
import colors from '../../HelperClasses/AppColor';
import appConfigStyle from '../../StyleSheets/AppConfigStyleSheet';
import PropTypes from 'prop-types';
import tableStyle from '../../StyleSheets/TableCommonStyleSheet';
import networkService from '../../Network/NetworkManager';
import Appload from '../../HelperClasses/AppLoaderClasses/AppLoader';
import downArrow_Icon from '../../assets/downArrowIcon.png';
import {AppToast} from '../../HelperClasses/AppToast';
import hideIcon from '../../assets/hideEye.png';
import showIcon from '../../assets/showEye.png';
import Switch from 'react-switch';
import commonStyle from '../../StyleSheets/CommonStyleSheet';
import HeaderView from '../HeaderView';
import AppConstants from '../../Constants/AppConstants';
import {Gradient} from 'react-gradient';
import SaveButton from '../../Component/SaveButton';
import HelperVideoView from '../../Component/HelperVideoView';

import {withLocale} from '../../Localization/LocaleContext';

const APPURL = require('../../Constants/URLConstants');
let KeyGroup = 'payments';
let AccountTypesArray = ['Standard', 'Express'];
const windowWidth = Dimensions.get('window').width;
const windowHeight = Dimensions.get('window').height;
let fixedWidth = AppConstants.mobileMaxWidth;
let itsMobileView = windowWidth < fixedWidth ? true : false;

class StripeIntegration extends Component {
  t = (key, paramsOrFallback, fallback) => this.props.localeContext?.translate?.(key, paramsOrFallback, fallback) || fallback || paramsOrFallback || key;
  constructor(props) {
    super(props);
    this.state = {
      updateUI: false,
      dataLoad: false,
      showDropDown: false,
      hideShowPublickey: false,
      hideShowSecretkey: false,
      publishableKey: '',
      secretKey: '',
      connectClientID: '',
      selectedAccountType: '',
      standardConnectMsg: '',
      standardDisConnectMsg: '',
      expressConnectMsg: '',
      expressDisConnectMsg: '',
      webhook: '',
      subscription_webhook: '',
      statusEnableBool: true,
      verifyStatus: null,
      verifyLoading: false,
      stripeAccount: null,
      webhookSetupStatus: null,
      webhookSetupLoading: false,
      showMarketplaceConnect: false,
      showSubscription: false,
      showSyncTooltip: false,
      syncStep: null,
      subWebhookLoading: false,
      subWebhookStatus: null,
    };
  }
  static propTypes = {
    backBtn: PropTypes.func,
    saveBtnCB: PropTypes.bool,
    embedded: PropTypes.bool,
    type: PropTypes.string,
  };
  componentDidMount() {
    this.loadConfigApi();
  }

  //MARK:-  APIs Method 
  loadConfigApi = async () => {
    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.config + '?key_group=payments',
      'get',
      '',
      '',
    );
    this.setState({currencyArray: []});
    if (responseJson['status'] == true) {
      var configs = responseJson['data']['configs'];
      this.setState({
        publishableKey: configs['stripe_api_publishable_key'] || '',
        secretKey: configs['stripe_api_secret_key'] || '',
        connectClientID: configs['stripe_client_id'] || '',
        webhook: configs['stripe_webhook_payment_intent_secret'] || '',
        subscription_webhook:
          configs['stripe_webhook_subscriptions_secret'] || '',
        statusEnableBool: configs['stripe_enabled'] || true,
        standardConnectMsg:
          configs['stripe_config_screen_connect_message_standard'] || '',
        standardDisConnectMsg:
          configs['stripe_config_screen_disconnect_message_standard'] || '',
        expressConnectMsg:
          configs['stripe_config_screen_connect_message_express'] || '',
        expressDisConnectMsg:
          configs['stripe_config_screen_disconnect_message_express'] || '',
      });
      if (this.state.standardConnectMsg.length != 0) {
        this.state.selectedAccountType = AccountTypesArray[0];
      } else if (this.state.expressConnectMsg.length != 0) {
        this.state.selectedAccountType = AccountTypesArray[1];
      }
    }
    this.setState({dataLoad: true});
  };

  addOrUpdateAppDetailApi = async filesData => {
    var configs = [];
    var valueArray = [
      this.state.publishableKey,
      this.state.secretKey,
      this.state.connectClientID,
      this.state.selectedAccountType.toLowerCase(),
      this.state.selectedAccountType == AccountTypesArray[0]
        ? this.state.standardConnectMsg
        : '',
      this.state.selectedAccountType == AccountTypesArray[0]
        ? this.state.standardDisConnectMsg
        : '',
      this.state.selectedAccountType == AccountTypesArray[1]
        ? this.state.expressConnectMsg
        : '',
      this.state.selectedAccountType == AccountTypesArray[1]
        ? this.state.expressDisConnectMsg
        : '',
      this.state.webhook,
      this.state.subscription_webhook,
      this.state.statusEnableBool,
    ];

    // var configs = [];
    for (let i = 0; i < keysArray.length; i++) {
      let scValue = false;
      if (i == 1 || i == 2) {
        scValue = true;
      }
      if (valueArray[i].length != 0) {
        let fDict = {
          key_group: KeyGroup,
          key: keysArray[i],
          value: valueArray[i],
          secured: scValue,
        };
        configs.push(fDict);
      }
    }
    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.config,
      'post',
      JSON.stringify({configs: configs}),
      '',
    );
    this.setState({dataLoad: true});
    if (responseJson['status'] == true) {
      this.deleteKeysAPI(configs);
      // this.alertView('Uploaded successfully');
    } else {
      this.deleteKeysAPI(configs);
      this.setState({dataLoad: true});
      this.alertView(responseJson);
    }
  };
  deleteKeysAPI = async Parameter => {
    var deleteParms = [];
    for (let q = 0; q < keysArray.length; q++) {
      deleteParms.push(keysArray[q]);
    }
    for (let a = 0; a < Parameter.length; a++) {
      let name = Parameter[a]['key'];
      let index = deleteParms.indexOf(name);
      deleteParms.splice(index, 1);
    }
    let parms = deleteParms.toString();
    let urlParm = APPURL.URLPaths.config + '?key=' + parms;
    const responseJson = await networkService.networkCall(urlParm, 'delete');
    this.setState({dataLoad: true});
    this.alertView('Uploaded successfully');
  };
  alertView(title) {
    if (Platform.OS === 'web') {
      // alert(title);
      AppToast();
    } else {
      Alert.alert(title);
    }
  }
  //MARK:-  Buttons Action Method 
  submitBtnAction() {
    this.setState({dataLoad: false, statusEnableBool: true});
    this.addOrUpdateAppDetailApi();
  }
  hideShowEyeBtnAction(id) {
    if (id == 1) {
      this.setState({hideShowPublickey: !this.state.hideShowPublickey});
    } else {
      this.setState({hideShowSecretkey: !this.state.hideShowSecretkey});
    }
  }
  openDropDown = id => {
    this.setState({showDropDown: !this.state.showDropDown});
  };
  didSelectDropDown = item => {
    this.setState({
      showDropDown: !this.state.showDropDown,
      selectedAccountType: item,
    });
  };
  toolTipBtnAction() {
    window.open(AppConstants.stripeYoutubeLink, '_blank');
  }
  openStripeOAuth = async () => {
    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.stripeConnectOAuth,
      'get',
      '',
      '',
    );
    if (responseJson['status'] == true) {
      const oauthUrl = responseJson['data']['oauth_url'];
      window.open(oauthUrl, '_blank');
    } else {
      AppToast(responseJson);
    }
  };
  fetchTenantUniqueId = async () => {
    try {
      const {getSelectedTenantDetails} = require('../../Constants/Functions');
      const responseJson = await networkService.networkCall(
        APPURL.URLPaths.clients,
        'get',
        '',
        '',
      );
      if (responseJson['status'] == true) {
        const tenants = getSelectedTenantDetails(responseJson['data']['tenants']);
        return tenants?.[0]?.['id'] || null;
      }
      return null;
    } catch {
      return null;
    }
  };
  createWebhook = async (secretKey, url, events) => {
    const params = new URLSearchParams();
    params.append('url', url);
    events.forEach(e => params.append('enabled_events[]', e));
    const resp = await fetch('https://api.stripe.com/v1/webhook_endpoints', {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + secretKey,
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
    return resp.json();
  };
  setupStripeWebhooks = async key => {
    const uniqueId = await this.fetchTenantUniqueId();
    if (!key || !uniqueId) {
      this.setState({webhookSetupStatus: 'error'});
      return;
    }
    this.setState({webhookSetupLoading: true, webhookSetupStatus: null});
    const base = AppConstants.BaseURL;
    try {
      const piResp = await this.createWebhook(
        key,
        `${base}v1/payments/stripe/webhook/paymentIntent/${uniqueId}`,
        ['payment_intent.succeeded'],
      );
      const piSecret = piResp.secret;
      if (piSecret) {
        this.setState({webhook: piSecret, webhookSetupStatus: 'ok'});
      } else {
        this.setState({webhookSetupStatus: 'error'});
      }
    } catch {
      this.setState({webhookSetupStatus: 'error'});
    }
    this.setState({webhookSetupLoading: false});
  };
  setupSubscriptionWebhook = async () => {
    const key = this.state.secretKey.trim();
    const uniqueId = await this.fetchTenantUniqueId();
    if (!key || !uniqueId) {
      this.setState({subWebhookStatus: 'error'});
      return;
    }
    this.setState({subWebhookLoading: true, subWebhookStatus: null});
    const base = AppConstants.BaseURL;
    try {
      const subResp = await this.createWebhook(
        key,
        `${base}v1/payments/stripe/webhook/subscriptions/${uniqueId}`,
        [
          'customer.subscription.created',
          'customer.subscription.updated',
          'customer.subscription.deleted',
        ],
      );
      const subSecret = subResp.secret;
      if (subSecret) {
        this.setState({subscription_webhook: subSecret, subWebhookStatus: 'ok'});
      } else {
        this.setState({subWebhookStatus: 'error'});
      }
    } catch {
      this.setState({subWebhookStatus: 'error'});
    }
    this.setState({subWebhookLoading: false});
  };
  syncStripeKey = async () => {
    const key = this.state.secretKey.trim();
    if (!key) {
      this.setState({verifyStatus: 'error', stripeAccount: null});
      return;
    }
    this.setState({verifyLoading: true, verifyStatus: null, stripeAccount: null, webhookSetupStatus: null, subWebhookStatus: null, syncStep: 'verifying'});
    try {
      const resp = await fetch('https://api.stripe.com/v1/account', {
        headers: {Authorization: 'Bearer ' + key},
      });
      const data = await resp.json();
      if (resp.ok && data.id) {
        this.setState({
          verifyStatus: 'ok',
          stripeAccount: {
            id: data.id,
            name: data.business_profile?.name || data.display_name || data.email || data.id,
            email: data.email,
            country: data.country,
            mode: key.startsWith('sk_live') ? 'Live' : 'Test',
          },
          verifyLoading: false,
          syncStep: 'webhooks',
        });
        await this.setupStripeWebhooks(key);
      } else {
        this.setState({verifyStatus: 'error', stripeAccount: null, verifyLoading: false, syncStep: null});
      }
    } catch {
      this.setState({verifyStatus: 'error', stripeAccount: null, verifyLoading: false, syncStep: null});
    }
    this.setState({syncStep: null});
  };
  //MARK:-  UIs 
  customDropDown = id => {
    if (this.state.showDropDown == true) {
      return (
        <View style={styles.showDropDownViewStyle}>
          <FlatList
            data={AccountTypesArray}
            horizontal={false}
            renderItem={this.renderDropDown}
            extraData={this.state}
            showsVerticalScrollIndicator={false}
            scrollEnabled={true}
          />
        </View>
      );
    }
    return <View></View>;
  };
  renderDropDown = ({item, index}) => {
    return (
      <TouchableOpacity
        onPress={() => this.didSelectDropDown(item, index)}
        style={{margin: 5, height: 30, marginBottom: 5}}>
        <View style={{justifyContent: 'center', width: '100%'}}>
          <Text style={commonStyle.dropdownCellItemTextStyle}>{item}</Text>
        </View>
      </TouchableOpacity>
    );
  };
  renderValueLabel = id => {
    return (
      <View
        style={{
          width: '100%',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}>
        <Text
          style={
            this.state.selectedAccountType == ''
              ? [
                  commonStyle.accountTypeplaceholderTxtStyle,
                  {outline: 0, width: '100%'},
                ]
              : [
                  commonStyle.accountTypetxtFieldStyle,
                  {outline: 0, width: '100%'},
                ]
          }>
          {this.state.selectedAccountType == ''
            ? 'Select account type'
            : this.state.selectedAccountType}
        </Text>
        <Image
          style={
            this.state.showDropDown == true
              ? styles.upArraowIconStyle
              : styles.downArraowIconStyle
          }
          resizeMode="contain"
          source={downArrow_Icon}
        />
      </View>
    );
  };

  accountTypesTextFields = () => {
    if (this.state.selectedAccountType == AccountTypesArray[0]) {
      return (
        <View>
          <View style={[commonStyle.subContainerViewStyle]}>
            <Text style={commonStyle.titleNameStyle}>{this.t('payments.connect_message_standard', 'Connect message standard')}</Text>
            <TextInput
              style={[
                commonStyle.txtFieldStyle,
                {outline: 0, marginLeft: 0, width: '100%'},
              ]}
              placeholder={this.t('payments.enter_connect_message_standard', 'Enter connect message standard')}
              placeholderTextColor={colors.placeholderColor}
              onChangeText={name => this.setState({standardConnectMsg: name})}
              value={this.state.standardConnectMsg}
            />
          </View>
          <View style={{height: 20}} />
          <View style={commonStyle.subContainerViewStyle}>
            <Text style={commonStyle.titleNameStyle}>{this.t('payments.disconnect_message_standard', 'Disconnect message standard')}</Text>
            <TextInput
              style={[
                commonStyle.txtFieldStyle,
                {outline: 0, marginLeft: 0, width: '100%'},
              ]}
              placeholder={this.t('payments.enter_disconnect_message_standard', 'Enter disonnect message standard')}
              placeholderTextColor={colors.placeholderColor}
              onChangeText={name =>
                this.setState({standardDisConnectMsg: name})
              }
              value={this.state.standardDisConnectMsg}
            />
          </View>
        </View>
      );
    } else if (this.state.selectedAccountType == AccountTypesArray[1]) {
      return (
        <View>
          <View style={commonStyle.subContainerViewStyle}>
            <Text style={commonStyle.titleNameStyle}>{this.t('payments.connect_message_express', 'Connect message express')}</Text>
            <TextInput
              style={[
                commonStyle.txtFieldStyle,
                {outline: 0, marginLeft: 0, width: '100%'},
              ]}
              placeholder={this.t('payments.enter_connect_message_express', 'Enter connect message express')}
              placeholderTextColor={colors.placeholderColor}
              onChangeText={name => this.setState({expressConnectMsg: name})}
              value={this.state.expressConnectMsg}
            />
          </View>
          <View style={{height: 20}} />
          <View style={commonStyle.subContainerViewStyle}>
            <Text style={commonStyle.titleNameStyle}>{this.t('payments.disconnect_message_express', 'Disconnect message express')}</Text>
            <TextInput
              style={[
                commonStyle.txtFieldStyle,
                {outline: 0, marginLeft: 0, width: '100%'},
              ]}
              placeholder={this.t('payments.enter_disconnect_message_express', 'Enter disonnect message express')}
              placeholderTextColor={colors.placeholderColor}
              onChangeText={name => this.setState({expressDisConnectMsg: name})}
              value={this.state.expressDisConnectMsg}
            />
          </View>
        </View>
      );
    } else {
      return <View />;
    }
  };
  renderSaveConfigBtn = () => {
    return (
      <View>
        <SaveButton
          saveBtn={() => this.submitBtnAction()}
          saveBtnTitle={'Save'}
        />
      </View>
    );
  };
  render() {
    const embedded = this.props.embedded;
    return (
      <SafeAreaView style={styles.Container}>
        {!embedded && (
          <View style={commonStyle.sidepanSaveBtnViewStyle}>
            {this.renderSaveConfigBtn()}
          </View>
        )}
        <ScrollView style={embedded ? {flex: 1} : {height: windowHeight / 1.18}}>
          <View style={commonStyle.sidepanmViewStyle}>
            <View style={{height: 20}} />
            {/* Secret key — shown first */}
            <View style={commonStyle.configContainerViewStyle}>
              <View style={{flexDirection: 'row', alignItems: 'center', marginBottom: 4}}>
                <Text style={[commonStyle.titleNameStyle, {flex: 1}]}>{this.t('payments.secret_key', 'Secret key')}</Text>
                <TouchableOpacity
                  onPress={() => window.open('https://dashboard.stripe.com/apikeys', '_blank')}
                  style={{paddingHorizontal: 6, paddingVertical: 2}}>
                  <Text style={{fontSize: 11, color: '#635bff', textDecorationLine: 'underline'}}>
                    {this.t('payments.stripe_get_keys', 'Get Stripe keys')} ↗
                  </Text>
                </TouchableOpacity>
                <TouchableOpacity
                  onPress={() => this.setState(s => ({showSyncTooltip: !s.showSyncTooltip}))}
                  style={{padding: 4}}>
                  <Text style={{fontSize: 14, color: 'var(--color-text-secondary)'}}>ⓘ</Text>
                </TouchableOpacity>
              </View>
              {this.state.showSyncTooltip && (
                <View style={{
                  marginBottom: 8, padding: 10, borderRadius: 8,
                  backgroundColor: 'var(--color-surface)',
                  borderWidth: 1, borderColor: 'var(--color-border)',
                }}>
                  <Text style={{fontSize: 12, color: 'var(--color-text-secondary)', lineHeight: 18}}>
                    {this.t('payments.stripe_sync_help', 'Sync verifies your secret key with Stripe, fills in your account information, and creates the webhook endpoints Tradly needs. Webhook secrets are filled in automatically; save the form when done.')}
                  </Text>
                </View>
              )}
              <View style={[commonStyle.customTxtFieldViewStyle, styles.keyFieldRow]}>
                <TextInput
                  style={[commonStyle.customTxtFieldStyle, styles.keyInput]}
                  placeholder={this.t('payments.enter_secret_key', 'Enter secret key')}
                  placeholderTextColor={colors.placeholderColor}
                  onChangeText={name => this.setState({secretKey: name, verifyStatus: null, stripeAccount: null, webhookSetupStatus: null})}
                  value={this.state.secretKey}
                  secureTextEntry={!this.state.hideShowSecretkey}
                />
                <TouchableOpacity
                  style={styles.eyeButton}
                  onPress={() => this.hideShowEyeBtnAction(2)}>
                  <Image
                    style={styles.hideShowIconStyle}
                    resizeMode="contain"
                    source={this.state.hideShowSecretkey ? showIcon : hideIcon}
                  />
                </TouchableOpacity>
                <TouchableOpacity
                  onPress={() => this.syncStripeKey()}
                  disabled={this.state.syncStep != null}
                  style={styles.verifyButton}>
                  <Text style={{color: '#fff', fontSize: 12, fontWeight: '600'}}>
                    {this.state.syncStep === 'verifying'
                      ? '⟳'
                      : this.state.syncStep === 'webhooks'
                      ? '⚙'
                      : 'Sync'}
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
            {this.state.syncStep != null && (
              <View style={{
                marginHorizontal: 10, marginBottom: 12,
                padding: 12, borderRadius: 10,
                borderWidth: 1, borderColor: 'var(--color-border)',
                backgroundColor: 'var(--color-surface)',
              }}>
                <View style={{flexDirection: 'row', alignItems: 'center', marginBottom: 8}}>
                  <Text style={{fontSize: 12, fontWeight: '600', color: 'var(--color-text)'}}>
                    {this.t('payments.stripe_syncing', 'Syncing with Stripe...')}
                  </Text>
                </View>
                {[
                  {key: 'verifying', label: this.t('payments.stripe_verifying_key', 'Verifying secret key')},
                  {key: 'webhooks', label: this.t('payments.stripe_creating_webhook', 'Creating payment webhook')},
                ].map((step, i) => {
                  const stepKeys = ['verifying', 'webhooks'];
                  const currentIdx = stepKeys.indexOf(this.state.syncStep);
                  const stepIdx = stepKeys.indexOf(step.key);
                  const done = stepIdx < currentIdx;
                  const active = stepIdx === currentIdx;
                  return (
                    <View key={step.key} style={{flexDirection: 'row', alignItems: 'center', marginBottom: 4}}>
                      <Text style={{
                        fontSize: 14, marginRight: 8,
                        color: done ? '#4ade80' : active ? '#635bff' : 'var(--color-text-secondary)',
                      }}>
                        {done ? '✓' : active ? '◌' : '○'}
                      </Text>
                      <Text style={{
                        fontSize: 12,
                        color: done ? '#4ade80' : active ? 'var(--color-text)' : 'var(--color-text-secondary)',
                        fontWeight: active ? '600' : '400',
                      }}>
                        {step.label}
                      </Text>
                    </View>
                  );
                })}
              </View>
            )}
            {this.state.verifyStatus === 'ok' && this.state.stripeAccount ? (
              <View style={{
                marginHorizontal: 10, marginBottom: 16,
                padding: 12, borderRadius: 10,
                borderWidth: 1, borderColor: 'rgba(52,199,89,0.4)',
                backgroundColor: 'rgba(52,199,89,0.08)',
                flexDirection: 'row', alignItems: 'center',
              }}>
                <Text style={{fontSize: 20, marginRight: 10}}>✅</Text>
                <View style={{flex: 1}}>
                  <Text style={{fontSize: 13, fontWeight: '600', color: 'var(--color-text)'}}>
                    {this.state.stripeAccount.name}
                  </Text>
                  {this.state.stripeAccount.email ? (
                    <Text style={{fontSize: 12, color: 'var(--color-text-secondary)', marginTop: 2}}>
                      {this.state.stripeAccount.email}
                    </Text>
                  ) : null}
                  <Text style={{fontSize: 11, color: 'var(--color-text-secondary)', marginTop: 2}}>
                    {this.t('payments.stripe_account_summary', {country: this.state.stripeAccount.country, mode: this.state.stripeAccount.mode, id: this.state.stripeAccount.id}, '{country} · {mode} mode · {id}')}
                  </Text>
                  {this.state.webhookSetupStatus === 'ok' && (
                    <Text style={{fontSize: 11, color: '#4ade80', marginTop: 6}}>
                      {this.t('payments.stripe_webhooks_configured', '✓ Webhooks configured — secrets auto-filled below. Save the form to persist.')}
                    </Text>
                  )}
                  {this.state.webhookSetupStatus === 'error' && (
                    <Text style={{fontSize: 11, color: '#f87171', marginTop: 6}}>
                      {this.t('payments.stripe_webhooks_error', '⚠ Webhook setup failed. Check your key permissions and try Sync again.')}
                    </Text>
                  )}
                </View>
              </View>
            ) : this.state.verifyStatus === 'error' ? (
              <View style={{
                marginHorizontal: 10, marginBottom: 16,
                padding: 12, borderRadius: 10,
                borderWidth: 1, borderColor: 'rgba(239,68,68,0.4)',
                backgroundColor: 'rgba(239,68,68,0.08)',
                flexDirection: 'row', alignItems: 'center',
              }}>
                <Text style={{fontSize: 20, marginRight: 10}}>❌</Text>
                <Text style={{fontSize: 13, color: '#ef4444'}}>
                  {this.t('payments.stripe_invalid_key', 'Invalid secret key. Check and try again.')}
                </Text>
              </View>
            ) : null}
            {this.props.type !== 'stripe_web' && (
              <View style={commonStyle.configContainerViewStyle}>
                <Text style={commonStyle.titleNameStyle}>{this.t('payments.publishable_key', 'Publishable key')}</Text>
                <View style={[commonStyle.customTxtFieldViewStyle, styles.keyFieldRow]}>
                  <TextInput
                    style={[commonStyle.customTxtFieldStyle, styles.keyInput]}
                    placeholder={this.t('payments.enter_publishable_key', 'Enter publishable key')}
                    placeholderTextColor={colors.placeholderColor}
                    onChangeText={name => this.setState({publishableKey: name})}
                    value={this.state.publishableKey}
                    secureTextEntry={!this.state.hideShowPublickey}
                  />
                  <TouchableOpacity
                    style={styles.eyeButton}
                    onPress={() => this.hideShowEyeBtnAction(1)}>
                    <Image
                      style={styles.hideShowIconStyle}
                      resizeMode="contain"
                      source={this.state.hideShowPublickey ? showIcon : hideIcon}
                    />
                  </TouchableOpacity>
                </View>
              </View>
            )}
            <View style={commonStyle.configContainerViewStyle}>
              <Text style={commonStyle.titleNameStyle}>
                {this.t('payments.payment_intent_webhook_secret', 'Payment Intent Webhook secret')}
              </Text>
              <TextInput
                style={[
                  commonStyle.txtFieldStyle,
                  {outline: 0, marginLeft: 0, width: '100%'},
                ]}
                placeholder={this.t('payments.enter_webhook_secret', 'Enter webhook secret')}
                placeholderTextColor={colors.placeholderColor}
                onChangeText={name => this.setState({webhook: name})}
                value={this.state.webhook}
              />
            </View>
            {/* Subscription collapsible */}
            <TouchableOpacity
              onPress={() => this.setState({showSubscription: !this.state.showSubscription})}
              style={{
                flexDirection: 'row', alignItems: 'center',
                marginHorizontal: 10, marginTop: 16, marginBottom: 4,
                paddingVertical: 10, paddingHorizontal: 12,
                borderRadius: 8,
                backgroundColor: 'var(--color-surface)',
                borderWidth: 1, borderColor: 'var(--color-border)',
              }}>
              <View style={{flex: 1}}>
                <Text style={{fontSize: 13, fontWeight: '600', color: 'var(--color-text)'}}>
                  {this.t('payments.subscription', 'Subscription')}
                </Text>
                <Text style={{fontSize: 11, color: 'var(--color-text-secondary)', marginTop: 2}}>
                  {this.t('payments.stripe_subscription_hint', 'Only needed if you sell subscription products on Tradly')}
                </Text>
              </View>
              <Text style={{fontSize: 16, color: 'var(--color-text-secondary)'}}>
                {this.state.showSubscription ? '▲' : '▼'}
              </Text>
            </TouchableOpacity>

            {this.state.showSubscription && (
              <View style={{
                marginHorizontal: 10, marginBottom: 10,
                borderWidth: 1, borderColor: 'var(--color-border)',
                borderTopWidth: 0, borderRadius: 8,
                borderTopLeftRadius: 0, borderTopRightRadius: 0,
                paddingBottom: 12,
              }}>
                <View style={commonStyle.configContainerViewStyle}>
                  <Text style={commonStyle.titleNameStyle}>
                    {this.t('payments.subscription_webhook_secret', 'Subscription Webhook secret')}
                  </Text>
                  <TextInput
                    style={[
                      commonStyle.txtFieldStyle,
                      {outline: 0, marginLeft: 0, width: '100%'},
                    ]}
                    placeholder={this.t('payments.enter_subscription_webhook_secret', 'Enter subscription webhook secret')}
                    placeholderTextColor={colors.placeholderColor}
                    onChangeText={name => this.setState({subscription_webhook: name})}
                    value={this.state.subscription_webhook}
                  />
                </View>
                <TouchableOpacity
                  onPress={() => this.setupSubscriptionWebhook()}
                  disabled={this.state.subWebhookLoading}
                  style={{
                    marginHorizontal: 10, marginTop: 8,
                    paddingVertical: 10, borderRadius: 8,
                    backgroundColor: '#635bff',
                    alignItems: 'center',
                  }}>
                  <Text style={{color: '#fff', fontSize: 13, fontWeight: '600'}}>
                    {this.state.subWebhookLoading
                      ? this.t('payments.subscription_setting_up', 'Setting up...')
                      : this.state.subWebhookStatus === 'ok'
                      ? `✓ ${this.t('payments.subscription_webhook_configured', 'Subscription webhook configured')}`
                      : this.state.subWebhookStatus === 'error'
                      ? `⚠ ${this.t('payments.subscription_retry_setup', 'Retry setup')}`
                      : `⚡ ${this.t('payments.setup_subscription_webhook', 'Setup Subscription Webhook')}`}
                  </Text>
                </TouchableOpacity>
                {this.state.subWebhookStatus === 'ok' && (
                  <Text style={{fontSize: 11, color: '#4ade80', marginTop: 6, marginHorizontal: 10}}>
                    {this.t('payments.webhook_secret_autofilled', 'Webhook secret auto-filled above — save the form to persist.')}
                  </Text>
                )}
                {this.state.subWebhookStatus === 'error' && (
                  <Text style={{fontSize: 11, color: '#f87171', marginTop: 6, marginHorizontal: 10}}>
                    {this.t('payments.stripe_setup_failed', 'Setup failed. Make sure your secret key is synced first.')}
                  </Text>
                )}
              </View>
            )}

            {/* Marketplace Connect collapsible */}
            <TouchableOpacity
              onPress={() => this.setState({showMarketplaceConnect: !this.state.showMarketplaceConnect})}
              style={{
                flexDirection: 'row', alignItems: 'center',
                marginHorizontal: 10, marginTop: 20, marginBottom: 4,
                paddingVertical: 10, paddingHorizontal: 12,
                borderRadius: 8,
                backgroundColor: 'var(--color-surface)',
                borderWidth: 1, borderColor: 'var(--color-border)',
              }}>
              <View style={{flex: 1}}>
                <Text style={{fontSize: 13, fontWeight: '600', color: 'var(--color-text)'}}>
                  {this.t('payments.stripe_marketplace_connect', 'Marketplace Connect')}
                </Text>
                <Text style={{fontSize: 11, color: 'var(--color-text-secondary)', marginTop: 2}}>
                  {this.t('payments.stripe_marketplace_hint', 'Only needed if you use Stripe Connect for marketplace payouts')}
                </Text>
              </View>
              <Text style={{fontSize: 16, color: 'var(--color-text-secondary)'}}>
                {this.state.showMarketplaceConnect ? '▲' : '▼'}
              </Text>
            </TouchableOpacity>

            {this.state.showMarketplaceConnect && (
              <View style={{
                marginHorizontal: 10, marginBottom: 10,
                borderWidth: 1, borderColor: 'var(--color-border)',
                borderTopWidth: 0, borderRadius: 8,
                borderTopLeftRadius: 0, borderTopRightRadius: 0,
                paddingBottom: 8,
              }}>
                <View style={commonStyle.configContainerViewStyle}>
                  <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                    <Text style={commonStyle.titleNameStyle}>{this.t('payments.connect_client_id', 'Connect client id')}</Text>
                    <TouchableOpacity onPress={() => window.open('https://dashboard.stripe.com/settings/connect', '_blank')}>
                      <Text style={{fontSize: 11, color: '#635bff', textDecorationLine: 'underline'}}>
                        {this.t('payments.find_in_stripe', 'Find in Stripe Dashboard')} ↗
                      </Text>
                    </TouchableOpacity>
                  </View>
                  <TextInput
                    style={[commonStyle.txtFieldStyle, {outline: 0, marginLeft: 0, width: '100%'}]}
                    placeholder={this.t('payments.enter_connect_client_id', 'Enter connect client id')}
                    placeholderTextColor={colors.placeholderColor}
                    onChangeText={name => this.setState({connectClientID: name})}
                    value={this.state.connectClientID}
                  />
                </View>
                <View style={[commonStyle.configContainerViewStyle, {zIndex: 10001}]}>
                  <Text style={commonStyle.titleNameStyle}>{this.t('payments.account_type', 'Account type')}</Text>
                  <TouchableOpacity
                    style={[commonStyle.dropDownViewStyle, {width: '100%', marginTop: 0}]}
                    onPress={() => this.openDropDown(2)}>
                    <this.renderValueLabel id={2} />
                    <this.customDropDown id={2} />
                  </TouchableOpacity>
                </View>
                <View style={{zIndex: 150}}>
                  <this.accountTypesTextFields />
                </View>
                <View style={{margin: 14}}>
                  <Text style={appConfigStyle.titleTxtStyle}>{this.t('payments.stripe_reminders', 'Stripe reminders')}</Text>
                  <TextInput
                    style={[appConfigStyle.txtFieldStyle, {outline: 0, width: '100%'}]}
                    placeholder={this.t('payments.title', 'Title')}
                    placeholderTextColor={colors.placeholderColor}
                    onChangeText={name => this.setState({inviteFriendTitle: name})}
                    value={this.state.inviteFriendTitle}
                  />
                  <TextInput
                    style={[appConfigStyle.descriptionTxtFieldStyle, {outline: 0, width: '100%'}]}
                    placeholder={this.t('payments.description', 'Description')}
                    placeholderTextColor={colors.placeholderColor}
                    onChangeText={name => this.setState({inviteFriendDescription: name})}
                    value={this.state.inviteFriendDescription}
                    multiline={true}
                  />
                </View>
              </View>
            )}
          </View>
          <View style={{height: 40}} />
          <View style={{display: 'flex', gap: 10}}>
            <HelperVideoView
              title={this.t('payments.learn_more_stripe', 'Learn More - Stripe Payments')}
              helperVideoBtnAction={() =>
                window.open('https://tradly.app/docs/stripe-payments')
              }
            />
            <HelperVideoView
              title={this.t('payments.learn_more_stripe_connect', 'Learn More - Stripe Connect for Marketplaces')}
              helperVideoBtnAction={() =>
                window.open('https://tradly.app/docs/stripe-connect')
              }
            />
          </View>
        </ScrollView>
        <Appload enable={this.state.dataLoad} />
      </SafeAreaView>
    );
  }
}
const styles = StyleSheet.create({
  Container: {
    flex: 1,
  },
  showDropDownViewStyle: {
    backgroundColor: colors.AppWhite,
    position: 'absolute',
    borderRadius: 5,
    borderWidth: 1,
    borderColor: 'rgba(230, 230, 230, 1)',
    width: '100%',
    marginTop: 38,
    marginLeft: 0,
    zIndex: 9000,
  },
  upArraowIconStyle: {
    width: 15,
    height: 15,
    marginRight: 20,
    alignSelf: 'center',
    transform: [{rotate: '180deg'}],
  },
  downArraowIconStyle: {
    width: 15,
    height: 15,
    alignSelf: 'center',
    marginRight: 20,
  },
  hideShowIconStyle: {
    width: 15,
    height: 15,
    alignSelf: 'center',
  },
  keyFieldRow: {
    boxSizing: 'border-box',
    padding: 0,
    marginTop: 0,
    width: '100%',
    minWidth: 0,
    minHeight: 40,
    height: 40,
    alignItems: 'center',
    justifyContent: 'flex-start',
    overflow: 'hidden',
  },
  keyInput: {
    flex: 1,
    minWidth: 0,
    width: 0,
    height: 40,
    marginTop: 0,
    borderRadius: 0,
    paddingHorizontal: 12,
    boxSizing: 'border-box',
  },
  eyeButton: {
    flexShrink: 0,
    width: 42,
    height: 40,
    alignItems: 'center',
    justifyContent: 'center',
  },
  verifyButton: {
    flexShrink: 0,
    marginRight: 8,
    paddingVertical: 6,
    paddingHorizontal: 12,
    borderRadius: 6,
    backgroundColor: '#635bff',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

let keysArray = [
  'stripe_api_publishable_key',
  'stripe_api_secret_key',
  'stripe_client_id',
  'stripe_connect_account_type',
  'stripe_config_screen_connect_message_standard',
  'stripe_config_screen_disconnect_message_standard',
  'stripe_config_screen_connect_message_express',
  'stripe_config_screen_disconnect_message_express',
  'stripe_webhook_payment_intent_secret',
  'stripe_webhook_subscriptions_secret',
  'stripe_enabled',
];

export default withLocale(StripeIntegration);
